import { useMemo, useState } from "react";

import AppButton from "../../../../../commons/buttons/AppButton";
import AppContainer from "../../../../../commons/containers/AppContainer";
import AppLinkButton from "../../../../../commons/buttons/AppLinkButton";
import AppLoading from "../../../../../commons/AppLoading";
import HallAppToast from "../../../../../commons/HallAppToast";
import SchedulingAPI from "../../../SchedulingAPI";
import { formatDate } from "../../../../../commons/util/HallAppUtil";

const schedulerAPI = new SchedulingAPI();

function ARStep4({ data, toBack, closeModal, getAllRecurrings }) {
  const [isLoading, setIsLoading] = useState(false);

  const translateFrequency = (value) => {
    switch (value) {
      case "DAILY": return "Diária";
      case "WEEKLY": return "Semanal";
      case "FORTNIGHTLY": return "Quinzenal";
      case "MONTHLY": return "Mensal";
      case "CUSTOM": return "Personalizada";
      default: return "-";
    }
  };

  const translateDuration = (value, repetitionCount) => {
    switch (value) {
      case "INFINITE": return "Sem data final (infinita)";
      case "REPETITION": return `Por ${repetitionCount} repetições`;
      case "SPECIFIC_DATE": return `Até uma data específica`;
      default: return "-";
    }
  };

  const translateWeek = (day) => {
    const map = {
      SUNDAY: "Domingo",
      MONDAY: "Segunda",
      TUESDAY: "Terça",
      WEDNESDAY: "Quarta",
      THURSDAY: "Quinta",
      FRIDAY: "Sexta",
      SATURDAY: "Sábado",
    };
    return map[day] || day;
  };

  const showWeeks =
    (data?.frequency === "CUSTOM" || data?.frequency === "WEEKLY") &&
    Array.isArray(data?.weeks) &&
    data.weeks.length > 0;

  const durationLabel = useMemo(
    () => translateDuration(data?.durationRecurrence, data?.duration),
    [data?.durationRecurrence, data?.duration]
  );

  const createOrUpdate = async () => {
    try {
      setIsLoading(true);
      const dataRecurring = {
        ...data,
        customerId: data.customer.id,
      };
      await schedulerAPI.createRecurringSchedule(dataRecurring);
      HallAppToast.success();
      if (closeModal) {
        getAllRecurrings?.();
        closeModal();
      }
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ paddingBottom: 110 }}>
      {/* Cabeçalho */}
      <div className="mb-3">
        <div style={{ fontSize: 16, fontWeight: 800, lineHeight: "20px" }}>
          Revisão final
        </div>
        <div className="text-muted" style={{ fontSize: 12 }}>
          Confira as informações antes de salvar.
        </div>
      </div>

      {/* Card: Cliente + Agenda */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: 16,
          padding: 14,
          marginBottom: 12,
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 800, color: "#1d1b4a" }}>
          Cliente e horário
        </div>

        <div className="mt-3 d-flex flex-column gap-2">
          <div className="d-flex align-items-center justify-content-between gap-3">
            <span className="text-muted" style={{ fontSize: 12 }}>Cliente</span>
            <span style={{ fontSize: 13, fontWeight: 800, textAlign: "right" }}>
              {data?.customer?.name || "—"}
            </span>
          </div>

          <div className="d-flex align-items-center justify-content-between gap-3">
            <span className="text-muted" style={{ fontSize: 12 }}>Início</span>
            <span style={{ fontSize: 13, fontWeight: 800 }}>
              {data?.startDate ? formatDate(data.startDate) : "—"}
            </span>
          </div>

          <div className="d-flex align-items-center justify-content-between gap-3">
            <span className="text-muted" style={{ fontSize: 12 }}>Horário</span>
            <span style={{ fontSize: 13, fontWeight: 800 }}>
              {data?.hours || "—"}
            </span>
          </div>
        </div>
      </div>

      {/* Card: Frequência e duração */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: 16,
          padding: 14,
          marginBottom: 12,
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 800, color: "#1d1b4a" }}>
          Frequência
        </div>

        <div className="mt-3 d-flex flex-column gap-2">
          <div className="d-flex align-items-center justify-content-between gap-3">
            <span className="text-muted" style={{ fontSize: 12 }}>Frequência</span>
            <span style={{ fontSize: 13, fontWeight: 800 }}>
              {translateFrequency(data?.frequency)}
            </span>
          </div>

          <div className="d-flex align-items-center justify-content-between gap-3">
            <span className="text-muted" style={{ fontSize: 12 }}>Duração</span>
            <span style={{ fontSize: 13, fontWeight: 800, textAlign: "right" }}>
              {durationLabel}
            </span>
          </div>

          {data?.durationRecurrence === "SPECIFIC_DATE" && (
            <div className="d-flex align-items-center justify-content-between gap-3">
              <span className="text-muted" style={{ fontSize: 12 }}>Até</span>
              <span style={{ fontSize: 13, fontWeight: 800 }}>
                {data?.specificDate ? formatDate(data.specificDate) : "—"}
              </span>
            </div>
          )}
        </div>

        {showWeeks && (
          <>
            <hr className="my-3" />
            <div className="text-muted mb-2" style={{ fontSize: 12 }}>
              Dias da semana
            </div>
            <div className="d-flex flex-wrap gap-2">
              {data.weeks.map((w) => (
                <span
                  key={w}
                  className="px-2 py-1 rounded-pill"
                  style={{
                    fontSize: 12,
                    fontWeight: 800,
                    background: "#f1f3ff",
                    color: "#2f2a7a",
                    border: "1px solid #e3e6ff",
                  }}
                >
                  {translateWeek(w)}
                </span>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Card: Serviços */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: 16,
          padding: 14,
          marginBottom: 12,
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 800, color: "#1d1b4a" }}>
          Serviços e profissionais
        </div>

        <div className="mt-3 d-flex flex-column gap-2">
          {(data?.services || []).map((s, idx) => (
            <div
              key={`${s?.serviceId || idx}-${idx}`}
              style={{
                border: "1px solid #eee",
                borderRadius: 14,
                padding: "10px 12px",
                background: "#fafafa",
              }}
              className="d-flex align-items-start justify-content-between gap-3"
            >
              <div style={{ minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 800,
                    color: "#111827",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={s?.serviceName}
                >
                  {s?.serviceName || "Serviço"}
                </div>

                <div className="text-muted" style={{ fontSize: 12 }}>
                  Profissional
                </div>
              </div>

              <div style={{ fontSize: 13, fontWeight: 800, color: "#1d1b4a", textAlign: "right" }}>
                {s?.employeeName || "—"}
              </div>
            </div>
          ))}

          {(!data?.services || data.services.length === 0) && (
            <div className="text-muted" style={{ fontSize: 12 }}>
              Nenhum serviço selecionado.
            </div>
          )}
        </div>
      </div>

      {/* Footer actions */}
      <div
        className="ar-footer-actions"
        style={{
          position: "sticky",
          bottom: 0,
          padding: "10px 0",
          background: "linear-gradient(to top, #fff 70%, rgba(255,255,255,0))",
          borderTop: "1px solid #eee",
        }}
      >
        <AppContainer>
          {isLoading ? (
            <AppLoading />
          ) : (
            <>
              <div style={{ marginBottom: 10 }}>
                <AppButton name="Salvar" width="100%" onClick={createOrUpdate} />
              </div>

              <AppLinkButton fullWidth={true} name="Voltar" width="100%" onClick={toBack} />
            </>
          )}
        </AppContainer>
      </div>
    </div>
  );
}

export default ARStep4;
